import axios from "../../../../apis/Api";
import history, { logout } from "../../../../history";
import storage from "../../../../apis/Storage";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import {
  GET_CURRENT_SHOP_WISE_TRANSACTION_DETAILS,
  RESET_CURRENT_SHOP_WISE_TRANSACTION_DETAILS,
  GET_MFIS,
} from "../../../../Types";

import fileSaver from "file-saver";
import * as XLSX from "xlsx";
export const getCurrentShopwiseTransactionsDetails =
  (requestData) => async (dispatch) => {
    dispatch(showLoading());
    await axios
      .post(`api/Reports/GetCurrentShopwiseTransactionsDetails`, requestData)
      .then(({ data }) => {
        if (data && data?.response)
          dispatch({
            type: GET_CURRENT_SHOP_WISE_TRANSACTION_DETAILS,
            payload: data.response,
          });
        dispatch(hideLoading());
      })
      .catch(function (error) {
        dispatch(hideLoading());
        if (error.response) {
          if (error.response.status === 401) {
            logout();
            history.push("/login");
            history.go("/login");
          } else if (
            error.response.status === 400 &&
            error.response.data.errors
          ) {
            let errorMessage = "";
            var errors = error.response.data.errors;
            var keys = Object.keys(errors);
            for (let j = 0; j < keys.length; j++) {
              errorMessage += errors[keys[j]] + " , \n";
            }
            toast.error(errorMessage);
          } else if (error.response.data)
            toast.error(
              error.response.data.Message
                ? error.response.data.Message
                : error.response.data.message
            );
          else {
            toast.error("Error while processing the request");
          }
        } else toast.error("Error while processing the request");
      });
  };

export const resetCurrentShopwiseTransactionsDetails =
  () => async (dispatch) => {
    dispatch({
      type: RESET_CURRENT_SHOP_WISE_TRANSACTION_DETAILS,
      payload: [],
    });
  };

export const getMfis = () => async (dispatch) => {
  await axios
    .get(`api/Mfi`)
    .then(({ data }) => {
      // if (data && data.length > 0)
      dispatch({
        type: GET_MFIS,
        payload: data.filter((x) => x.isDropDown == true),
      });
    })
    .catch(function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const exportReport = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/Reports/ExportCurrentShopwiseTransactionDetails`, requestData)
    .then(({ data }) => {
      const outputFilename = `Shopwise_Transactions_Details_Report_${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const getCustomColumns = (csvData, selectedColumns) => {
        return csvData.map((row) => {
          let filteredRow = {};
          selectedColumns.forEach((column) => {
            if (row.hasOwnProperty(column)) {
              filteredRow[column] = row[column];
            }
          });
          return filteredRow;
        });
      };

      const exportToCSV = (csvData, jobNumber, fileName) => {
        console.log(csvData);
        csvData = getCustomColumns(csvData, [
          "distributionId",
          "shopId",
          "shopName",
          "invoiceNumber",
          "payment",
          "paymentStatus",
          "noOfTransactions",
        ]);
        console.log(csvData);
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
            ws[address].v =
              ws[address].v == "distributionId"
                ? "Distribution Id"
                : ws[address].v == "shopId"
                ? "Shop Id"
                : ws[address].v == "shopName"
                ? "Shop Name"
                : ws[address].v == "invoiceNumber"
                ? "Invoice Number"
                : ws[address].v == "orderAmount"
                ? "Order Amount"
                : ws[address].v == "payment"
                ? "Payment"
                : ws[address].v == "paymentStatus"
                ? "Payment Status"
                : ws[address].v == "noOfTransactions"
                ? "No. Of Transactions"
                : ws[address].v;
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToCSV(data.response, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
